export enum MailFilterNavigation {
  Inbox = 0,
  OutBox = 1,
  Send = 3,
  Starred = 4,
  UnRead = 5,
  Read = 6,
  StarredApplications = 7,
  StarredOthers = 8,
  CustomFolder = 9
}
